import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {Routes,Route,Link,BrowserRouter as Router}from 'react-router-dom';
import LandingPage from './components/LandingPage';
import MyResume from './components/Resume/MyResume';
import PageNotFound from './components/pageNotFound/PageNotFound';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Router>
  <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="resume" element={<MyResume />} />
    <Route path="*" element={<PageNotFound />} />

  
  </Routes>
</Router>
    
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
